import { activeSpeakerObserver } from '@livekit/components-core'
import * as React from 'react'
import { useRoomContext } from '../../context'
import { useObservableState } from '../internal'

/**
 * The `useSpeakingParticipants` hook returns the only the active speakers of all participants.
 *
 * @example
 * ```tsx
 * const activeSpeakers = useSpeakingParticipants();
 * ```
 * @public
 */
export function useSpeakingParticipants() {
  const room = useRoomContext()
  const speakerObserver = React.useMemo(() => activeSpeakerObserver(room), [room])
  const activeSpeakers = useObservableState(speakerObserver, room.activeSpeakers)
  return activeSpeakers
}
